/**
 * O'qdagi yorliq ko'rinadimi.
 *
 * Yorliqlar SIYRAKLASHTIRILADI (har `step` tadan biri), oxirgisi esa HAR
 * DOIM ko'rinadi — grafikning o'ng chegarasi qaysi kun ekani bilinsin.
 * Oxirgisiga `step` dan yaqin turgan qadam yorlig'i tashlanadi: aks holda
 * "21 Sen" va "23 Sen" bir-birining ustiga chiqardi.
 */
export const showAxisLabel = (index: number, length: number, step: number): boolean => {
  const last = length - 1;
  if (index === last) return true;
  return index % step === 0 && last - index >= step;
};

/** Sakkizta yorliq — o'qni bo'sh qoldirmaydigan va ustma-ust tushmaydigan oraliq. */
export const axisStep = (length: number): number => Math.max(1, Math.ceil(length / 8));
